export default __webpack_public_path__ + "media/images/theme/wordmark_light-3b105d95a6f98758e3311c33eee64538.png";